import { Link, type Location, useLocation } from 'react-router';

import { Button, Circle, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react';

import { CircleExclamation } from '@enterprise/ui';

const UnexpectedError = () => {
  const location = useLocation() as Location<{ from: string } | undefined>;

  const previousPath = location.state?.from ?? '/datastream/packagemanager';

  return (
    <Flex
      alignItems="center"
      bg="red.50"
      justifyContent="center"
      minH="100vh"
      px={6}>
      <VStack
        bg="white"
        border="1px solid"
        borderColor="red.100"
        borderRadius="xl"
        maxW="420px"
        p={10}
        spacing={4}
        textAlign="center"
        w="full">
        <Circle
          bg="red.50"
          size="72px">
          <CircleExclamation
            color="var(--chakra-colors-red-500)"
            size="4x"
          />
        </Circle>

        <Heading
          fontSize="xl"
          fontWeight="medium">
          Something went wrong
        </Heading>

        <Text
          color="gray.500"
          fontSize="sm"
          lineHeight="tall">
          An unexpected error occurred. Try going back or returning home.
        </Text>

        <HStack pt={2}>
          <Button
            as={Link}
            colorScheme="red"
            size="sm"
            to="/datastream/packagemanager">
            Take me home
          </Button>
          <Button
            as={Link}
            colorScheme="red"
            size="sm"
            to={previousPath}
            variant="outline">
            Go back
          </Button>
        </HStack>
      </VStack>
    </Flex>
  );
};

export default UnexpectedError;
